var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewLater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59833 8.18379C3.44745 3.74927 7.36302 0.399902 12.0331 0.399902C17.3165 0.399902 21.6094 4.69282 21.6094 9.97624C21.6094 15.307 17.3165 19.5999 12.0331 19.5999C10.4763 19.5999 8.96677 19.2225 7.59856 18.5149C7.26829 18.3262 7.12686 17.9017 7.26829 17.5714C7.457 17.2411 7.88156 17.0997 8.21184 17.2884C9.3912 17.9017 10.7122 18.1847 12.033 18.1847C16.5618 18.1847 20.1943 14.5051 20.1943 9.97632C20.1943 5.44752 16.5618 1.81495 12.033 1.81495C7.97595 1.81495 4.57961 4.73983 3.91892 8.60797L5.75869 7.28705C6.08896 7.09834 6.51353 7.14549 6.74938 7.47575C6.98523 7.75874 6.89094 8.18344 6.56067 8.4193L3.49437 10.6365C3.21138 10.8723 2.73953 10.778 2.55082 10.4949L0.333635 7.42861C0.0977869 7.09835 0.192073 6.67378 0.475197 6.43793C0.805465 6.20208 1.23003 6.29637 1.46588 6.57949L2.59833 8.18379Z",
    fill: "#FFA900",
    stroke: "#FFA900",
    strokeWidth: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewLater);
export default __webpack_public_path__ + "static/media/review_later.b5ea82cfafe78b6638e98019b5f74037.svg";
export { ForwardRef as ReactComponent };